import { render, staticRenderFns } from "./JSvgIcon.vue?vue&type=template&id=ba7c4dca&scoped=true"
import script from "./JSvgIcon.vue?vue&type=script&lang=js"
export * from "./JSvgIcon.vue?vue&type=script&lang=js"
import style0 from "./JSvgIcon.vue?vue&type=style&index=0&id=ba7c4dca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba7c4dca",
  null
  
)

export default component.exports